import { useEffect, useState } from "react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_rental-hub-india-11/artifacts/ww02po42_Tripzo%20new.png";

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#1e2528]/80 backdrop-blur-xl border-b border-[#3e4b55]/50"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 flex items-center justify-between h-20 md:h-24">
        <a
          href="#top"
          data-testid="brand-logo"
          className="flex items-center gap-3 group"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
        >
          <span
            aria-hidden="true"
            className="block h-10 md:h-12 w-10 md:w-12 bg-no-repeat bg-center bg-contain"
            style={{
              backgroundImage: `url(${LOGO_URL})`,
              backgroundSize: "200% auto",
              backgroundPosition: "center 25%",
            }}
          />
          <span className="font-display text-2xl md:text-3xl tracking-wider text-[#f7f7f7] leading-none">
            TRIPZO
          </span>
          <span className="hidden md:inline-block ml-2 text-[10px] tracking-[0.25em] uppercase text-[#e89b1f] border border-[#e89b1f]/40 px-2 py-0.5 rounded-sm">
            Coming Soon
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-9 text-sm tracking-wide text-[#ccd3d6]">
          <button
            data-testid="nav-fleet"
            onClick={() => scrollTo("fleet")}
            className="link-underline hover:text-[#e89b1f] transition-colors"
          >
            Fleet
          </button>
          <button
            data-testid="nav-features"
            onClick={() => scrollTo("features")}
            className="link-underline hover:text-[#e89b1f] transition-colors"
          >
            Features
          </button>
          <button
            data-testid="nav-contact"
            onClick={() => scrollTo("contact")}
            className="link-underline hover:text-[#e89b1f] transition-colors"
          >
            Contact
          </button>
        </nav>

        <button
          data-testid="nav-cta-waitlist"
          onClick={() => scrollTo("waitlist")}
          className="font-medium text-sm tracking-wide bg-[#e89b1f] text-[#1e2528] px-4 md:px-5 py-2.5 hover:bg-[#ffc543] transition-colors rounded-sm"
        >
          Join Waitlist
        </button>
      </div>
    </header>
  );
};
